"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CardPriceGuide = void 0;
var lib_1 = require("../lib");
var CardPriceGuide = /** @class */ (function () {
    function CardPriceGuide(_a) {
        var attributes = _a.attributes, priceGuide = _a.priceGuide;
        if (attributes) {
            this.attributes = attributes;
        }
        else if (priceGuide) {
            var AVG1 = priceGuide.AVG1, AVG7 = priceGuide.AVG7, AVG30 = priceGuide.AVG30, FoilAVG1 = priceGuide.FoilAVG1, FoilAVG7 = priceGuide.FoilAVG7, FoilAVG30 = priceGuide.FoilAVG30, Trend = priceGuide.Trend, FoilTrend = priceGuide.FoilTrend;
            this.attributes = [AVG1, AVG7, AVG30, FoilAVG1, FoilAVG7, FoilAVG30, Trend, FoilTrend];
        }
        else {
            throw new Error('invalid parameters');
        }
    }
    Object.defineProperty(CardPriceGuide.prototype, "AVG1", {
        get: function () {
            return this.attributes[0];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CardPriceGuide.prototype, "AVG7", {
        get: function () {
            return this.attributes[1];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CardPriceGuide.prototype, "AVG30", {
        get: function () {
            return this.attributes[2];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CardPriceGuide.prototype, "FoilAVG1", {
        get: function () {
            return this.attributes[3];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CardPriceGuide.prototype, "FoilAVG7", {
        get: function () {
            return this.attributes[4];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CardPriceGuide.prototype, "FoilAVG30", {
        get: function () {
            return this.attributes[5];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CardPriceGuide.prototype, "Trend", {
        get: function () {
            return this.attributes[6];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CardPriceGuide.prototype, "FoilTrend", {
        get: function () {
            return this.attributes[7];
        },
        enumerable: false,
        configurable: true
    });
    CardPriceGuide.prototype.convert = function (rate) {
        return new CardPriceGuide({
            attributes: this.attributes.map(function (val) {
                return val ? (0, lib_1.roundTo2Decimals)(val * rate) : val;
            }),
        });
    };
    CardPriceGuide.prototype.toPlainObject = function () {
        return {
            AVG1: this.AVG1,
            AVG7: this.AVG7,
            AVG30: this.AVG30,
            FoilAVG1: this.FoilAVG1,
            FoilAVG7: this.FoilAVG7,
            FoilAVG30: this.FoilAVG30,
            Trend: this.Trend,
            FoilTrend: this.FoilTrend,
        };
    };
    return CardPriceGuide;
}());
exports.CardPriceGuide = CardPriceGuide;
//# sourceMappingURL=CardPriceGuide.js.map